import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'
export const EnderecoList = (props) => <DefaultDataTable data={props} />
